
interface CTASectionProps {
  onShowForm: () => void;
}

export default function CTASection({ onShowForm }: CTASectionProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            今すぐ行動を起こしませんか？
          </h2>
          <p className="text-xl opacity-90">
            停止による利益損失は、1日遅れるごとに拡大します
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-white/10 rounded-2xl p-8 backdrop-blur-sm border border-yellow-400/30">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-yellow-500/20 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-video-line text-3xl text-yellow-400"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold">30分オンライン見学</h3>
                <p className="opacity-90">実際の動作をリアルタイムで確認</p>
              </div>
            </div>
            
            <div className="space-y-3 mb-6">
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>パレットからアーバー取り出し</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>AI自動摩耗検査</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>自動インサート交換</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>履歴ログ確認</span>
              </div>
            </div>
            
            <button 
              onClick={onShowForm}
              className="w-full bg-yellow-500 text-gray-900 py-4 rounded-lg font-semibold text-lg hover:bg-yellow-600 transition-colors cursor-pointer"
            >
              見学を予約する
            </button>
          </div>

          <div className="bg-white/10 rounded-2xl p-8 backdrop-blur-sm border border-yellow-400/30">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-yellow-500/20 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-calculator-line text-3xl text-yellow-400"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold">ROI結果と資料の先行受取</h3>
                <p className="opacity-90">御社専用の効果試算をお届け</p>
              </div>
            </div>
            
            <div className="space-y-3 mb-6">
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>LP上での概算値をPDF送付</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>詳細技術資料</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>業界別導入事例</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-check-line text-yellow-400"></i>
                <span>導入プロセス詳細</span>
              </div>
            </div>
            
            <button 
              onClick={onShowForm}
              className="w-full bg-yellow-500 text-gray-900 py-4 rounded-lg font-semibold text-lg hover:bg-yellow-600 transition-colors cursor-pointer"
            >
              ROI結果と資料を受け取る
            </button>
          </div>
        </div>

        <div className="text-center">
          <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm inline-block border border-yellow-400/30">
            <p className="text-lg font-semibold mb-2">
              ※営業からのしつこい電話は致しません
            </p>
            <p className="opacity-90">
              必要事項のみご入力ください。資料送付後のフォローアップは最小限に留めます。
            </p>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-4 gap-6 text-center">
          <div className="space-y-2">
            <div className="text-3xl font-bold text-yellow-400">1,000万円</div>
            <div className="text-sm opacity-90">年間利益改善効果</div>
          </div>
          <div className="space-y-2">
            <div className="text-3xl font-bold text-yellow-400">70%</div>
            <div className="text-sm opacity-90">交換時間短縮</div>
          </div>
          <div className="space-y-2">
            <div className="text-3xl font-bold text-yellow-400">90%</div>
            <div className="text-sm opacity-90">属人化解消</div>
          </div>
          <div className="space-y-2">
            <div className="text-3xl font-bold text-yellow-400">24/7</div>
            <div className="text-sm opacity-90">安定稼働設計</div>
          </div>
        </div>
      </div>
    </section>
  );
}
